import React from "react";
import "./evereg.css";
import 'animate.css';

export default function Everegprops(props) {
  return (
    <div className="rcard animate__animated animate__bounceIn" data-aos="fade-down">
      <div className="rcol">
        <img
          src={props.logo}
          alt="register_img"
        />
        <div className="rcontent">
          <h3>{props.isfor}</h3>

          <a href="/">{props.desclink}</a>
          <br />
          <button className="animate__animated animate__heartBeat animate__repeat-2">
            Register <i className="fa-solid fa-arrow-right-from-bracket"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
